module.exports = __webpack_public_path__ + "ee744b44305ce56ff805879edc1d37fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/northwestern_university_1_2023_chart.png
// module id = 1701
// module chunks = 0